/*
    Alta en el directorio
 */

(function (el) {
  //si no estamos en signup, nos vamos
  if (!el) {
    return;
  }

  //nuevo router, y configuramos
  let signUpRouter = new VueRouter({
    routes: [
      { path: '/', component: ProfileStart },
      { path: '/informacion', component: ProfileInfo },
      { path: '/experiencia', component: ProfileExperience },
      { path: '/disponibilidad', component: ProfileAvailability },
      { path: '/notificaciones', component: ProfileNotifications },
      { path: '*', redirect: '/' },
    ],
  });

  //lanzamos aplicación
  new Vue({
    store: store,
    router: signUpRouter,
    components: {
      Adsense,
    },
    computed: {
      ...Vuex.mapState(['signup', 'profile']),
    },
    created: function () {
      axios
        .get('/directorio/datos/')
        .then((r) => r.data)
        .then((data) => {
          ['alerts', 'activities', 'availability'].map((key) => {
            if (!data.profile.hasOwnProperty(key)) {
              data.profile[key] = [];
            }
          });

          if (
            !data.profile.hasOwnProperty('schedules') ||
            data.profile.schedules.length === 0
          ) {
            data.profile.schedules = ['week.morning', 'week.evening'];
          }

          if (!data.profile.hasOwnProperty('languages')) {
            data.profile.languages = ['spanish'];
          }

          if (!data.profile.hasOwnProperty('notify')) {
            data.profile.notify = true;
          }

          this.$store.commit('set', data);
          this.$emit('signup.loaded');
        });

      this.$on('save.profile', this.save);

      this.$store.commit('set', { signup: true });
      this.$router.afterEach((to, from) => {
        this.$emit('save.profile');
      });
    },
    methods: {
      toggleProfile() {
        this.profile.type = 'P';
      },
      save() {
        axios
          .post('/directorio/datos/', { profile: this.profile })
          .then((data) => data.data)
          .then((data) => {
            window.scrollTo(0, 0);
          })
          .catch((error) => {
            console.error(error);
            UIkit.modal.alert('Error al guardar, por favor revisa tus datos');
          });
      },
    },
    template: `
      <div>

        <h1
          v-if="$router.currentRoute.path === '/'"
          class="uk-text-center uk-margin-medium-top uk-margin-medium-bottom"
        >Bienvenido a Doméstiko</h1>

        <h1
          v-if="$router.currentRoute.path !== '/'"
          class="uk-text-center uk-margin-medium-top uk-margin-medium-bottom"
        >
          Completa tu perfil
          <span v-if="profile.type === 'E'">de empresa</span>
        </h1>
        <p v-if="profile.type === 'E' && signup" class="uk-text-center uk-margin-small-top">
          Si no eres una empresa
          <a href="#" @click="toggleProfile">completa tu perfil de usuario aquí</a>.
        </p>

        <Adsense unit="8491481656" />

        <ul
          v-if="$router.currentRoute.path !== '/'"
          class="signup-menu uk-subnav uk-child-width-1-4 uk-flex-center uk-text-center"
        >
          <li>
            <router-link to="/informacion">
              <img src="/assets/img/icons/line/informacion.svg" alt="Información" />
              <span>Información</span>
            </router-link>
          </li>
          <li>
            <router-link to="/experiencia">
              <img src="/assets/img/icons/line/experiencia.svg" alt="Experiencia" />
              <span v-if="profile.type === 'E'">Actividad</span>
              <span v-else>Experiencia</span>
            </router-link>
          </li>
          <li>
            <router-link to="/disponibilidad">
              <img src="/assets/img/icons/line/disponibilidad.svg" alt="Disponibilidad" />
              <span>Disponibilidad</span>
            </router-link>
          </li>
          <li>
            <router-link to="/notificaciones">
              <img src="/assets/img/icons/line/notificaciones.svg" alt="Notificaciones" />
              <span>Notificaciones</span>
            </router-link>
          </li>
        </ul>
        <router-view></router-view>

      </div>
    `,
  }).$mount(el);
})(document.getElementById('user-signup'));
